<template>
  <v-alert
    :class="[expireFlash ? 'expire-v-alert' : 'reg-v-alert']"
    :value="alertToggle"
    :color="messageData.color"
    transition="scale-transition"
  >
    <span v-if="doTranslation">{{ messageData.messageText | translate }}</span>
    <span v-else>{{ messageData.messageText }}</span>
    <v-btn
      v-if="!expireFlash && messageData.showRegisterButton"
      @click="redirectToRegister()"
      >{{ "lng_register_title" | translate }}</v-btn
    >
    <v-btn v-else-if="expireFlash" @click="redirectToPayment()">{{
      "lng_go_to_payment_text" | translate
    }}</v-btn>
  </v-alert>
</template>
<script>
import router from "./../router.js";
import { startStatusTimer } from "../common/HelperFunctions";

export default {
  data: () => ({
    timerInstance: undefined
  }),
  props: {
    messageData: {
      type: Object,
      default: () => {}
    },
    alertToggle: {
      type: Boolean,
      default: true
    },
    doTranslation: {
      type: Boolean,
      default: true
    },
    expireFlash: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.setFlashTimer();
    this.messageData.saved === "lng_save_ok" ? startStatusTimer() : "";
  },
  beforeDestroy() {
    clearTimeout(this.timerInstance);
  },
  methods: {
    redirectToRegister() {
      this.$emit("alertToggleUpdate");
      router.push("/register");
    },
    redirectToPayment() {
      this.$emit("alertToggleUpdate");
      router.push("/plans");
    },
    setFlashTimer() {
      this.timerInstance = setTimeout(() => {
        this.$emit("alertToggleUpdate");
      }, 5000);
    }
  }
};
</script>

<style>
.reg-v-alert {
  padding: 4px 15px;
  border-color: rgba(0, 0, 0, 0.12) !important;
  position: fixed;
  top: 0;
  right: 5px;
  z-index: 7;
  border: 0;
  border-radius: 3px;
  min-width: 300px;
  font-size: 15px;
  color: #fff;
}
.reg-v-alert .v-btn {
  color: rgba(255, 255, 255, 0.87);
  background-color: rgb(84, 110, 122) !important;
}

.expire-v-alert {
  padding: 4px 15px;
  border-color: rgba(0, 0, 0, 0.12) !important;
  position: fixed;
  top: 60px;
  right: 5px;
  z-index: 7;
  border: 0;
  border-radius: 3px;
  min-width: 300px;
  font-size: 15px;
  color: #fff;
}
.expire-v-alert .v-btn {
  color: rgba(255, 255, 255, 0.87);
  background-color: rgb(84, 110, 122) !important;
}
</style>
